const t=t=>{if(!t||0===t.length)return;let e=t[0];for(let r=1;r<t.length;r++)t[r]>e&&(e=t[r]);return e};export{t as max};
//# sourceMappingURL=max.js.map
